/**
 * Class for handling all interactions from the search bar
 *
 * This class emits 1 event:
 * -- searchFormDisplayChange: Triggered when the display type changes from map-tile to grid or other view types
 *
 * @param {string} id The DOM identifier for the form div, including its "#" character
 */
function SearchForm(id) {
    this.elem = document.getElementById(id);

    //Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    //Attach an event handler for when the display type changes
    $(document).on("change", "#display", this.evtDisplayChange.bind(this));

    //Attach an event handler to AJAX search form submissions
    jQuery(this.elem).on("submit", this.evtSubmit.bind(this));

    //On pageload, assign the display type based on the session display data
    if (storageAvailable("localStorage")) {
        var display = window.sessionStorage.getItem("search-form-display");

        if(display) {
            $("#display").val(display).trigger("change");
        }
    }

    this.initialize();
}

/**
 * Local Storage checker
 */
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
    } catch (e) {
        return false;
    }
}

SearchForm.prototype.evtSubmit = function(evt, params) {
    evt.preventDefault();

    if(!params || params.ajax) {
        evt.preventDefault();

        var search = new Search();
        search.execute();
    } else {
        var loc = jQuery("#search-location");

        if(jQuery.trim(loc.val()) !== '' && loc.val() == loc.data('term')) {
            jQuery(evt.target).attr('action', loc.data('url'));
        } else {
            jQuery(evt.target).attr('action', '/WhereToGo');
        }
    }
};

SearchForm.prototype.update = function(changed_element) {
    if(changed_element == 'search') {
        jQuery("#CityID, #StateID, #DestID, #CountryID, #u, #c, #s, #d, #sw_lat, #sw_lng, #ne_lat, #ne_lng, #zoom, #center_lat, #center_lng").remove();
        removePlaceholders();
        jQuery(this.elem).find("[name=pageNumber]").val(1);
        jQuery(this.elem).trigger("submit", { ajax: false });
    } else {
        jQuery(this.elem).trigger("submit");
    }
};

SearchForm.prototype.change = function(filters) {
    var gridchange = false;
    var amenchange = false;
    for (var filter in filters) {

        if(filter=='gridS') gridchange = true;
        var value = filters[filter];

        if(jQuery(this.elem).find("[name='" + filter + "']").length > 0){
            var f = jQuery(this.elem).find('[name=\''+filter+'\']');

            if(f.attr('type')=='checkbox')
                f.prop('checked',value).change();
            else
                f.val(value);
                if(filter=='arrival' || filter=='departure' || filter=='display' || filter=='sw_lat')
                    f.change();

            var last_changed = filter;
        }
        else{
            jQuery(this.elem).append('<input type="hidden" name="' + filter + '" id="' + filter + '" value="' + value + '" />');
        }
    }
};

/**
 * Initializes datepickers for the date fields in the search bar (Exact/Flexible start date/end date)
 */
SearchForm.prototype.initializeSearchDates = function(start, end) {
    var self = this;

    jQuery(start).datepicker({
        changeMonth: false,
        changeYear: false,
        minDate: 0,
        onClose: function(val) {
            jQuery(this).blur();
        }
    }).change(function() {
        var val = jQuery.trim(jQuery(this).val());
        
        var i = new Date(val);
        var i2 = new Date(val);
        var o = jQuery(end).val();
        
        i2.setDate(i.getDate() + 1);

        if(o == jQuery(end).attr('placeholder')) {
            o = '';
        }

        var o2 = new Date(o);

        if(val === '' || val == jQuery(this).attr('placeholder')) {
            jQuery(end).val('').datepicker("option", "minDate", 0);
            self.update(jQuery(this).attr("name"));
        } else {
            jQuery(end).datepicker("option", "minDate", i2);

            if(o === '' || o2 < i2) {
                window.search_calendar.setGridStart(val,false);
                window.setTimeout(function() {
                    jQuery(end).datepicker("show");
                }, 150);
            } else {
                var new_date = window.search_calendar.getGridStartFromRange(i, o2);
                window.search_calendar.setGridStart(new_date, true);
            }
        }
    });
    
    jQuery(end).datepicker({
        changeMonth: false,
        changeYear: false,
        minDate: 0,
        onClose: function(val) {
            jQuery(this).blur();
        }
    }).change(function() {
        var o = jQuery.trim(jQuery(this).val());
        var i = jQuery(start).val();
        
        if(o == jQuery(this).attr('placeholder')) {
            o = '';
        }

        var o2 = new Date(o);
        
        if(i == jQuery(start).attr('placeholder')) {
            i = '';
        }

        var i2 = new Date(i);
        var new_date = window.search_calendar.getGridStartFromRange(i2,o2);
        window.search_calendar.setGridStart(new_date, false);
    });
};

SearchForm.prototype.initialize = function(is_search_page, map) {
    createLoader('#section-rentals');

    this.initializeSearchDates("#search-arrival","#search-departure");
    this.initializeSearchDates("#flexStart","#flexEnd");
};

SearchForm.prototype.evtDisplayChange = function(evt) {
    var searchResultsPage = $("#search-results-page");
    var searchViewToggle = $("#search-view-toggle");
    var mview = searchViewToggle.data('map');
    var cview = searchViewToggle.data('calendar');

    searchResultsPage.removeClass();

    if(evt.target.value === "calendar") {
        searchResultsPage.addClass("calendar");
        searchViewToggle.text(mview);
    } else if(evt.target.value === "list") {
        searchResultsPage.addClass("list");
        searchViewToggle.text(cview);
    } else if(evt.target.value === "map") {
        searchResultsPage.addClass("map");
        searchViewToggle.text(cview);
    }

    //Update the local storage so that this will be stored between pages
    if (storageAvailable("localStorage")) {
        window.sessionStorage.setItem("search-form-display", evt.target.value);
    }

    //Send out the display changed event for all listeners to handle
    jQuery("#search-results-page").trigger("searchFormChangeDisplay", [ evt.target.value ]);
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchForm.prototype.searchComplete = function(evt, res, search) {
    //Serialize the parameters to a URL encoded query string
    var paramsURL = jQuery.param(search.searchData);

    if(history.pushState) {
        window.history.pushState({'data' : paramsURL}, document.title, "?submit=Search&" + paramsURL);
    } else {
        window.location.hash = "submit=Search&" + paramsURL;
    }

    //Update the "1-30 of 90 rentals" text
    jQuery(".resultsFrom").text(res.offset + 1);
    jQuery(".resultsTo").text(res.offset + res.count);
    jQuery(".resultsOf, .mapResultsOf").text(res.total);
    jQuery(".mapResultsTo").text(res.count);

    //Hide or display the X-X of X rentals count if there are no results
    jQuery("#section-rentals .section-count").toggle(res.total !== "0");
    
    //Hides and shows number of results notice and statuses 
    if(res.total === "0") {
        jQuery(".map-loader-no-results-notice").addClass('visible');
        jQuery("#map-loader-results").hide();
        jQuery("#map-loader-no-results").show();
    } else {
        jQuery(".map-loader-no-results-notice").removeClass('visible');
        jQuery("#map-loader-no-results").hide();
        jQuery("#map-loader-results").show();
    }
};
window.SearchForm = SearchForm;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchForm.js
// module id = 5
// module chunks = 0